package com.parmartechnologies.core.feature.offerBanner.network

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class OfferBannerRetrieveRequest(
    @SerialName("business_id") val BusinessID: String,
    @SerialName("feature_object_id") val featureObjectID: String = "",
)
@Serializable
data class OfferBannerCreateRequest(
    @SerialName("business_id") val BusinessID: String,
    @SerialName("user_id") val UserID: String,
    @SerialName("ImageString") val file: String,
)
@Serializable
data class OfferBannerDeleteRequest(
    @SerialName("_id") val _id: String,
)